<template>
	<div class="ogm-input" :class="{error:!isValidOGM}">
		<label>{{ label }}</label>
		<div class="ogm-container">
			<span>+++</span>
			<input
				ref="part1"
				v-model="part1"
				type="text"
				maxLength="3"
				@input="handleInput(1)"
				@paste="handlePaste"
				@keydown.delete="handleBackspace(1)"
			>
			<span>/</span>
			<input
				ref="part2"
				v-model="part2"
				type="text"
				maxLength="4"
				@input="handleInput(2)"
				@keydown.delete="handleBackspace(2)"
			>
			<span>/</span>
			<input
				ref="part3"
				v-model="part3"
				type="text"
				maxLength="5"
				@input="handleInput(3)"
				@keydown.delete="handleBackspace(3)"
			>
			<span>+++</span>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			part1: "",
			part2: "",
			part3: "",
		};
	},
	props: {
		value: {
			type: String,
		},
		label: String
	},
	computed: {
		ogmCode() {
			return this.part1 + this.part2 + this.part3;
		},
		isValidOGM() {

			if(this.ogmCode.length<=0){
				return true;
			}

			let cleanedOgm = this.ogmCode.replace(/\D/g, "");
			if (cleanedOgm.length !== 12) return false;
			let baseNumber = cleanedOgm.slice(0, 10);
			let checkDigits = parseInt(cleanedOgm.slice(10), 10);
			let calculatedCheck = parseInt(baseNumber, 10) % 97;
			return calculatedCheck === (checkDigits === 0 ? 97 : checkDigits);

		}
	},
	watch: {
		ogmCode(newVal) {
			this.$emit("input", newVal);
		}
	},
	methods: {
		handleInput(part) {
			if (part === 1) {
				this.part1 = this.part1.replace(/\D/g, "").slice(0, 3);
				if (this.part1.length === 3) this.$refs.part2.focus();
			}
			if (part === 2) {
				this.part2 = this.part2.replace(/\D/g, "").slice(0, 4);
				if (this.part2.length === 4) this.$refs.part3.focus();
			}
			if (part === 3) {
				this.part3 = this.part3.replace(/\D/g, "").slice(0, 5);
			}
		},
		handleBackspace(part) {
			if (part === 2 && this.part2.length === 0) {
				this.$refs.part1.focus();
			}
			if (part === 3 && this.part3.length === 0) {
				this.$refs.part2.focus();
			}
		},
		handlePaste(event) {
			event.preventDefault();
			let pastedData = event.clipboardData.getData("text");
			pastedData = pastedData.replace(/\D/g, "").slice(0, 12);
			this.onInput(pastedData);
		},
		onInput(ogm){
			if (ogm.length >= 3) {
				this.part1 = ogm.slice(0, 3);
				this.$refs.part2.focus();
			}
			if (ogm.length >= 7) {
				this.part2 = ogm.slice(3, 7);
				this.$refs.part3.focus();
			}
			if (ogm.length > 7) {
				this.part3 = ogm.slice(7, 12);
			}
		}
	},
	mounted(){
		let i = this.value.replace(/\D/g, "").slice(0, 12);
		this.onInput(i);
	}
};
</script>

<style scoped>
.ogm-input {
	display: flex;
	flex-direction: column;
	border:1px solid var(--main-gray-2);
	padding: 3px 10px;
	border-radius: 5px;
}

label{ color:var(--main-gray-5); font-size: 12px; }

.ogm-container {
	display: flex;
	align-items: center;
	font-size: 18px;
}

input {
	width: 50px;
	text-align: center;
	border-radius: 5px;
	margin: 0 5px;
	border:none;
	padding: 2px 0 2px 0;
	background: transparent;
}
.ogm-input.error{ border-color:var(--main-danger); background: var(--background-danger) }
.ogm-input.error label{ color:var(--main-danger); }
span{ font-weight: normal; font-size: var(--main-font-size); }
input:focus,input:active{ border:none; outline:none; }
</style>
